// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6114242e","694":"e1435823","707":"9e407c86"}[chunkId] + ".chunk.js";
};